import React, { useEffect } from 'react';
import Nav from './nav'
import Header from './header'
import Footer from './footer'
import { getItem, clearStorage } from '../../../utils/localStorage';
import { toastify } from '../../../utils/toast';
import { useNavigate } from 'react-router-dom';
import { makeRequest,makeRequest2 } from '../../../utils/makeRequest';
import { checkTokenExpirationURL ,checkAuthorizationURL} from '../../../utils/urls'

function Layout({ children }) {
  const navigate = useNavigate()
  const checkUserExistInLocalStorage = async () => {
    const userExist = await getItem('APPUSER')

    if (userExist === null || userExist === undefined) {
      toastify('You have been logged out, Kindly login', 'error')
      navigate('/')
    }
  }
  const checkJwtExpiration = async () => {
    try {
      const userDetailsValue = await getItem('APPUSER')
      const userDetails = JSON.parse(userDetailsValue)
      const token = userDetails.authToken
      const response = await makeRequest(checkTokenExpirationURL, 'POST', {
        token: token
      })

      if (response.success) {
        if (response.success.data) {
          await clearStorage()
          navigate('/')
        }
      }

    }
    catch (err) {
      console.log(err.message)
    }
  }
  const checkUnathorized = async () => {
    try {
      const response = await makeRequest2(checkAuthorizationURL, 'GET');

      if (response.error === 'Error: 401 - Your session has expired. Please log in again.') {
        await clearStorage()
        navigate('/')
      }
    }
    catch (err) {
      console.log(err.message)
    }
  }
  useEffect(() => {
    checkUserExistInLocalStorage()
    checkJwtExpiration()
    checkUnathorized()
  }, [])
  return (
    <>
      <Nav />
      <Header />
      <div className="pc-container">
        <div className="pc-content">
          {children}
        </div>
      </div>

      <Footer />
    </>
  );
}
export default Layout;